import React from 'react';
import {
    useGetList,
    Loading
} from 'react-admin';

export function useClosedStatusId() {
    const {
        data: closedStatus, isLoading, error,
    } = useGetList('Status', {
        filter: { q: 'Closed' }
    });

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        console.log(`Error fetching the 'Closed status' status : ${error}`);
    }

    let closedStatusId = null;
    if (closedStatus && closedStatus.length > 0) {
        closedStatusId = closedStatus[0].id;
    }

    return closedStatusId;
}
